"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelect = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const locale_1 = require("../../../../utils/locale");
const legacy_1 = require("../Select/legacy");
const localeLabels = {
    en: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/LanguageSelect/Name:English', defaultMessage: 'English' })),
    de: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/LanguageSelect/Name:German', defaultMessage: 'German' })),
    fr: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/LanguageSelect/Name:French', defaultMessage: 'French' })),
    sq: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/LanguageSelect/Name:Albanian', defaultMessage: 'Albanian' })),
};
const items = [
    '',
    ...locale_1.allLocales.map(value => ({
        name: localeLabels[value],
        value,
    })),
];
const LanguageSelect = (props) => {
    const formFieldSelectProps = {
        ...props,
        items,
    };
    return react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { ...formFieldSelectProps });
};
exports.LanguageSelect = LanguageSelect;
//# sourceMappingURL=index.js.map